import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  weight: {
    color: themeColor.modalTitle,
    marginTop: 3,
  },
  readme: {
    color: theme.palette.info.main,
    direction: 'ltr',
  },
  weightItem: {
    marginRight: 20,
  },
  weightItemInverse: {
    marginLeft: 20,
    direction: 'ltr',
  },
  disabled: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
  adjustOverflow: {
    '@media (max-height: 768px)': {
      fontSize: rem(0.65),
    },
  },
  class3Icon: {
    verticalAlign: 'middle',
  },
  iconAndTextContainer: {
    width: 'auto',
  },
  scaleIconContainer: {
    width: 'auto',
    paddingLeft: 2,
  },
}));
